<template>

  <svg
    t="1632580932028"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4229"
    width="64"
    height="64"
  ><path d="M512.3 201.8L719.72 392 812 307.4 512.3 32 212 307.4 304.94 392 512.3 201.8z m-0.6 620.4L304.28 632 212 716.6 511.7 992 812 716.6 719.06 632 511.7 822.2z" p-id="4230" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconSelectArrow',
} as DefineComponent
</script>